var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from "react";
import { observer } from "mobx-react";
import { Trans, withTranslation } from "react-i18next";
import Drawer from "@material-ui/core/Drawer";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { BsArrowLeft } from 'react-icons/bs';
import { debounce } from "lodash";
import ReportsSelector from "./ReportsSelector";
import SingleReport from "./SingleReport";
import { sortReportsByDate, SourceFilter } from "./helpers";
import { withStore } from "../../store/rootStore";
import ErrorBoundary from "../ErrorBoundary";
import classNames from "classnames";
import { getDirection } from "../../helpers";
import s from "./BulkReportsDrawer.module.scss";
class BulkReportsDrawer extends Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "setSearchValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.setState({ searchValue: value });
            }
        });
        Object.defineProperty(this, "setDateRangeValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                if (value === null) {
                    this.setState({ dateRangeValue: [null, null] });
                }
                else {
                    this.setState({ dateRangeValue: value });
                }
            }
        });
        Object.defineProperty(this, "setMinTotalClients", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.setState({ minTotalClients: value });
            }
        });
        Object.defineProperty(this, "setSourceFilter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.setState({ sourceFilter: value });
            }
        });
        Object.defineProperty(this, "selectReport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                this.setState({ selectedReportId: id });
                this.props.store.bulkReports.fetchSingleBulkReport(id);
            }
        });
        Object.defineProperty(this, "onUpdateComment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (comment) => {
                if (this.state.selectedReportId) {
                    this.props.store.bulkReports.updateSingleBulkReport(this.state.selectedReportId, { comment });
                }
            }
        });
        Object.defineProperty(this, "onUpdateTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (title) => {
                if (this.state.selectedReportId) {
                    this.props.store.bulkReports.updateSingleBulkReport(this.state.selectedReportId, { title });
                }
            }
        });
        Object.defineProperty(this, "onDownloadContacts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type) => {
                const { selectedReportId } = this.state;
                if (selectedReportId) {
                    this.props.store.bulkReports.downloadListOfContacts(selectedReportId, type);
                }
            }
        });
        Object.defineProperty(this, "onDownloadAllData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const { selectedReportId } = this.state;
                if (selectedReportId) {
                    this.setState({ downloadAllDataLoading: true });
                    yield this.props.store.bulkReports.downloadAllData(selectedReportId);
                    this.setState({ downloadAllDataLoading: false });
                }
            })
        });
        Object.defineProperty(this, "onLoadMore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const query = this._createQuery();
                this.props.store.bulkReports.fetchBulkReports(query, true);
            }
        });
        Object.defineProperty(this, "onSendNewBulkMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.toggleBulkMessageDrawer();
            }
        });
        Object.defineProperty(this, "hasActiveFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.state.minTotalClients) {
                    return this.state.minTotalClients > 0;
                }
                if (this.state.sourceFilter !== SourceFilter.ALL) {
                    return true;
                }
                return false;
            }
        });
        Object.defineProperty(this, "_createQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                const { searchValue, dateRangeValue, minTotalClients, sourceFilter } = this.state;
                const beforeTimestamp = dateRangeValue[1] !== null && (((_a = dateRangeValue === null || dateRangeValue === void 0 ? void 0 : dateRangeValue[1]) === null || _a === void 0 ? void 0 : _a.unix()) * 1000).toString();
                const afterTimestamp = dateRangeValue[0] !== null && (dateRangeValue[0].unix() * 1000).toString();
                const search = searchValue.length > 2 ? searchValue : null;
                return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (beforeTimestamp && { beforeTimestamp })), (afterTimestamp && { afterTimestamp })), (search && { search })), (minTotalClients && { minTotalClients: minTotalClients.toString() })), (sourceFilter === SourceFilter.API && { isApiSend: true })), (sourceFilter === SourceFilter.INBOX && { isApiSend: false }));
            }
        });
        Object.defineProperty(this, "fetchBulkReportsDebounced", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: debounce((query) => this.props.store.bulkReports.fetchBulkReports(query), 1000)
        });
        this.state = {
            searchValue: "",
            minTotalClients: 5,
            dateRangeValue: [null, null],
            sourceFilter: SourceFilter.ALL,
            selectedReportId: null,
            downloadAllDataLoading: false,
        };
    }
    componentDidMount() {
        this.props.store.bulkReports.fetchScheduledReports();
    }
    componentDidUpdate(prevProps, prevState) {
        const { searchValue, dateRangeValue, minTotalClients, sourceFilter } = this.state;
        const query = this._createQuery();
        const search = searchValue.length > 2 ? searchValue : null;
        if (prevState.dateRangeValue !== dateRangeValue || prevState.searchValue !== searchValue || prevState.sourceFilter !== sourceFilter) {
            if (prevState.searchValue !== searchValue && !search && searchValue !== "")
                return;
            this.props.store.bulkReports.fetchBulkReports(query);
        }
        if (prevState.minTotalClients !== minTotalClients) {
            this.fetchBulkReportsDebounced(query);
        }
        if (!prevProps.isOpen && this.props.isOpen) {
            this.props.store.bulkReports.fetchBulkReports(query);
        }
    }
    render() {
        const { toggleBulkReportsDrawer, isOpen, store } = this.props;
        const { searchValue, dateRangeValue, selectedReportId, downloadAllDataLoading, minTotalClients, sourceFilter } = this.state;
        return (React.createElement(Drawer, { open: isOpen, onClose: () => toggleBulkReportsDrawer(), anchor: getDirection() === "rtl" ? "right" : "left", dir: getDirection(), style: { zIndex: 100 }, classes: {
                root: s["message-drawer__root"],
                paperAnchorLeft: s["message-drawer__paperAnchorLeft"],
                paperAnchorRight: s["message-drawer__paperAnchorRight"],
            } },
            React.createElement("div", { className: classNames(s["message-drawer__container"], {
                    [s.rtl]: getDirection() === "rtl",
                }) },
                React.createElement("div", { className: s["message-drawer__header"] },
                    React.createElement("div", { className: classNames(s["message-drawer__back"], {
                            [s.rtl]: getDirection() === "rtl",
                        }) },
                        React.createElement(ListItemIcon, { onClick: () => toggleBulkReportsDrawer() },
                            React.createElement(BsArrowLeft, null)),
                        React.createElement("span", { className: s["message-drawer__title"] },
                            React.createElement(Trans, { i18nKey: "bulkMessagesReports" })))),
                React.createElement("div", { className: s["message-drawer__selector"] },
                    React.createElement(ErrorBoundary, null,
                        React.createElement(ReportsSelector, { reportsList: [
                                ...store.bulkReports.reportsList,
                                ...store.bulkReports.scheduledReportsList
                            ].sort(sortReportsByDate), searchValue: searchValue, setSearchValue: this.setSearchValue, dateRangeValue: dateRangeValue, setDateRangeValue: this.setDateRangeValue, minTotalClients: minTotalClients, setMinTotalClients: this.setMinTotalClients, sourceFilter: sourceFilter, setSourceFilter: this.setSourceFilter, selectedReportId: selectedReportId, selectReport: this.selectReport, onLoadMore: this.onLoadMore, onSendNewBulkMessage: this.onSendNewBulkMessage, hasMore: store.bulkReports.searchHasMore || false, loading: store.bulkReports.bulkReportsLoading, loadingMore: store.bulkReports.bulkReportsLoadingMore, hasActiveFilters: this.hasActiveFilters() }))),
                React.createElement("div", { className: s["message-drawer__main"] },
                    React.createElement(ErrorBoundary, null,
                        React.createElement(SingleReport, { report: store.bulkReports.singleReport, loading: store.bulkReports.singleBulkReportLoading, downloadAllDataLoading: downloadAllDataLoading, onUpdateComment: this.onUpdateComment, onUpdateTitle: this.onUpdateTitle, onDownloadContacts: this.onDownloadContacts, onDownloadAllData: this.onDownloadAllData }))))));
    }
}
export default withTranslation()(withStore(observer(BulkReportsDrawer)));
